import React from 'react';
import { SkeletonContentTile } from '../../../Shared/Skeleton';
import './HomeSectionSkeleton.scss';

export type HomeSectionSkeletonProps = {
  /** Prefix for the skeleton's test ids, e.g. `your-courses-skeleton`. */
  testId: string;
  tileCount?: number;
};

/**
 * Shared loading placeholder, so each section shows a skeleton in its own slot
 * rather than the page blanking behind one spinner.
 */
const HomeSectionSkeleton = ({
  testId,
  tileCount = 3,
}: HomeSectionSkeletonProps) => (
  <section aria-busy="true" data-testid={testId}>
    <div
      className={`home-section-skeleton__tiles${
        tileCount === 1 ? ' home-section-skeleton__tiles--single' : ''
      }`}
      aria-hidden="true"
      data-testid={`${testId}-tiles`}
    >
      {Array.from({ length: tileCount }, (_, index) => (
        <div key={index} data-testid={`${testId}-tile`}>
          <SkeletonContentTile />
        </div>
      ))}
    </div>
  </section>
);

export default HomeSectionSkeleton;
